import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import {Toolbar} from "../components/Toolbar";
import "../styles/About.css";

const jmImage = "/images/jm_pic.jpg";

export const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page-container">
      <Toolbar />
      <section className="about-content-layout">
        <button className="about-back-btn" onClick={() => navigate(-1)}>
          <ChevronLeft size={20} />
          Back
        </button>

        <div className="about-main-content">
          <div className="about-image-container">
            <img src={jmImage} className="about-image" />
          </div>

          <div className="about-text-section">
            <h1 className="about-title">About Augio</h1>
            <p className="about-description">
              I built Augio to be a curated, media-first platform that
              organizes independent music geographically. The mission is to give
              independent artists the spotlight they deserve, free from the bias
              of major labels and platforms. We are starting a new era of discovery and
              connection, one where we map the talent in every region, allowing
              artists to grow authentic audiences and fans to truly connect with
              the creators defining their local sound.
            </p>
            <p className="about-description">Founder - Joe Murphy</p>
          </div>
        </div>
      </section>
    </div>
  );
};
